import React from 'react';
import MenuItem from '@material-ui/core/MenuItem';
import Chip from '@material-ui/core/Chip';
import { Card } from 'semantic-ui-react'
class View extends React.Component {

  state = {

  }

  remove(number, type, id) {
    let data = this.props.data;
    let items = [];
    if (type == 'primary') {
      data.map((z) =>{
        if (id == z.id) {
          if (z.altmobile) {
            items.push({ id: z.id, name: z.name, mobile: z.altmobile, taluk: z.taluk, type: z.type })
          }
          else {

          }
        }
        else {
          items.push(z);
        }
      });
    }
    else {
      data.map((z) => {
        if (id == z.id) {
          items.push({ id: z.id, name: z.name, mobile: z.mobile, taluk: z.taluk, type: z.type })
        }
        else {
          items.push(z);
        }
      })
    }
    this.props.updateData(items);
  }

  render() {
    return (
      <div style={{paddingLeft: '2%'}}>
        { this.props.data.map((z) => {
            return(
              <Card>
                <Card.Content>
                  {z.id+"->"+z.name+"  ("+z.taluk+")"}<br/><br/>
                  <Chip label={z.mobile} onDelete={this.remove.bind(this, z.mobile, 'primary', z.id)} />
                  { (z.altmobile == null || z.altmobile == '' || z.altmobile == undefined || z.altmobile == ' ') ?
                    (
                      <div></div>
                    ) :
                    (
                      <Chip label={z.altmobile} onDelete={this.remove.bind(this, z.altmobile, 'secoundary', z.id)} />
                    )
                  }
                </Card.Content>
              </Card>
            )
          })
        }
      </div>
    );
  }
}

export default View;
